import { gql } from '@apollo/client';

// --- Queries ---

export const GET_FUNCTIONAL_LOCATION = gql`
  query GetFunctionalLocation($_id: String!, $teamId: String) {
    getFunctionalLocation(_id: $_id, teamId: $teamId) {
      _id
      name
      parentId
      teamId
      senderName
    }
  }
`;

export const GET_FUNCTIONAL_LOCATIONS = gql`
  query FunctionalLocations($first: Int, $after: String, $teamId: String) {
    functionalLocations(first: $first, after: $after, teamId: $teamId) {
      page {
        edges {
          node {
            _id
            name
            parentId
            teamId
            senderName
            description
            deviceCount
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const GET_DEVICES_BY_FUNCTIONAL_LOCATION = gql`
  query GetDevicesByFunctionalLocation($locationId: String!) {
    getDevicesByFunctionalLocation(locationId: $locationId) {
      _id
      name
    }
  }
`;

// --- Mutations ---

export const CREATE_FUNCTIONAL_LOCATION = gql`
  mutation CreateFunctionalLocation($payload: FunctionalLocationInput!) {
    createFunctionalLocation(payload: $payload) {
      _id
      name
      parentId
      teamId
      senderName
      description
    }
  }
`;

export const UPDATE_FUNCTIONAL_LOCATION = gql`
  mutation UpdateFunctionalLocation($payload: FunctionalLocationInput!) {
    updateFunctionalLocation(payload: $payload) {
      _id
      name
      parentId
      teamId
      senderName
      description
    }
  }
`;

export const DELETE_FUNCTIONAL_LOCATION = gql`
  mutation DeleteFunctionalLocation($_id: String!) {
    deleteFunctionalLocation(_id: $_id)
  }
`;
